import React from 'react';
import styles from './ProgressNumbers.module.css';

interface ProgressNumbersProps {
  currentQuestionIndex: number;
  questionCount: number;
}

export const ProgressNumbers = ({ currentQuestionIndex, questionCount }: ProgressNumbersProps) => {
  const currentPage = currentQuestionIndex + 1;

  return (
    <span className={styles.progress}>
      <span className={styles.currentPage}>{currentPage}</span>
      <span className={styles.total}>{`/${questionCount}`}</span>
    </span>
  );
};
